module.exports = __webpack_public_path__ + "static/img/271_TO8_2379_og.f8682d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/271_TO8_2379_og.jpg
// module id = trv9
// module chunks = 0